import { StepType, WizardStep } from '@app/components/wizard/wizard.component';
import { StepSectionType } from './steps.enums';
import { StepsBySection } from './steps.models';

export const defaultProjectWizardSteps: StepsBySection = new Map<
  StepSectionType,
  WizardStep<StepSectionType>
>([
  [
    StepSectionType.baseData,
    {
      title: 'general.basicData',
      isActive: true,
      stepType: StepType.locked,
      sectionType: StepSectionType.baseData,
    },
  ],
  [
    StepSectionType.a,
    {
      icon: 'A',
      title: 'projectWizard.sectionAForm.formTitle',
      isActive: false,
      stepType: StepType.available,
      sectionType: StepSectionType.a,
    },
  ],
  [
    StepSectionType.b,
    {
      icon: 'B',
      title: 'projectWizard.sectionBForm.formTitle',
      isActive: false,
      stepType: StepType.available,
      sectionType: StepSectionType.b,
    },
  ],
  [
    StepSectionType.c,
    {
      icon: 'C',
      title: 'projectWizard.sectionCForm.formTitle',
      isActive: false,
      stepType: StepType.available,
      sectionType: StepSectionType.c,
    },
  ],
  [
    StepSectionType.d,
    {
      icon: 'D',
      title: 'projectWizard.sectionDForm.formTitle',
      isActive: false,
      stepType: StepType.available,
      sectionType: StepSectionType.d,
    },
  ],
  [
    StepSectionType.e,
    {
      icon: 'E',
      title: 'projectWizard.sectionEForm.formTitle',
      isActive: false,
      stepType: StepType.available,
      sectionType: StepSectionType.e,
    },
  ],
  [
    StepSectionType.f,
    {
      icon: 'F',
      title: 'projectWizard.sectionFForm.formTitle',
      isActive: false,
      stepType: StepType.available,
      sectionType: StepSectionType.f,
    },
  ],
  [
    StepSectionType.g,
    {
      icon: 'G',
      title: 'projectWizard.sectionGForm.formTitle',
      isActive: false,
      stepType: StepType.available,
      sectionType: StepSectionType.g,
    },
  ],
  [
    StepSectionType.h,
    {
      icon: 'H',
      title: 'projectWizard.sectionHForm.formTitle',
      isActive: false,
      stepType: StepType.available,
      sectionType: StepSectionType.h,
    },
  ],
  [
    StepSectionType.i,
    {
      icon: 'I',
      title: 'projectWizard.sectionIForm.formTitle',
      isActive: false,
      stepType: StepType.available,
      sectionType: StepSectionType.i,
    },
  ],
  [
    StepSectionType.j,
    {
      icon: 'J',
      title: 'projectWizard.sectionJForm.formTitle',
      isActive: false,
      stepType: StepType.available,
      sectionType: StepSectionType.j,
    },
  ],
]);

export interface DefaultProjectWizardStepsOptions {
  isReadOnly?: boolean;
  foundingMode?: number;
}

export function getDefaultProjectWizardSteps(
  options: DefaultProjectWizardStepsOptions = {},
): StepsBySection {
  const steps = new Map(defaultProjectWizardSteps);

  if (options.isReadOnly) {
    for (const [key, step] of steps.entries()) {
      steps.set(key, { ...step, stepType: StepType.locked });
    }
  }

  if (options.foundingMode === 2) {
    const loanPurposeDisabledSections = [
      StepSectionType.e,
      StepSectionType.f,
    ];
    for (const section of loanPurposeDisabledSections) {
      const step = steps.get(section);
      if (step) {
        steps.set(section, { ...step, stepType: StepType.disabled });
      }
    }
  }

  return steps;
}
